module.exports = __webpack_public_path__ + "img/pen-pink.157117ec.svg";